import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  useLocation,
  useNavigate,
  useOutlet,
} from "react-router-dom";
import { useTranslation } from "react-i18next";

import useAutoLogout from "../hooks/useAutoLogout";
import { useUIContext } from "../Context/UIContextProvider";
import { SavePrevLocation } from "../redux/authReducer";
import { loginService } from "../WebApiServices/login.service";

import { GetLocalStorageData } from "../Helpers/Utilities";
import { helperText } from "../Helpers/helperText";
import { PAGE_ROUTES } from "../Helpers/Enums";

export const PrivateRoute = () => {
  const { t: translation } = useTranslation();
  const location = useLocation();
  const outlet = useOutlet();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);

  const { ToggleSessionTimeout } = useUIContext();
  const NON_RESUMABLE_ROUTES = [PAGE_ROUTES.CONTACT];

  const sessionTimeoutPopup = translation("popups.sessionTimeout", {
    returnObjects: true,
  });

  // useEffect(() => {
  //   if (
  //     !auth.isLoggedIn &&
  //     !NON_RESUMABLE_ROUTES.includes(location.pathname)
  //   ) {
  //     dispatch(SavePrevLocation(location.pathname));
  //   }
  // }, [auth.isLoggedIn, location.pathname]);

  useEffect(() => {
    if (auth.urlBeforeLogin !== "" && GetLocalStorageData("eUser")) {
      dispatch(SavePrevLocation(""));
    }
  }, [auth.urlBeforeLogin]);

  useEffect(() => {
    const IsUserActive = async () => {
      try {
        await loginService.IsUserActive();
      } catch (error) {}
    };

    IsUserActive();
  }, []);

  useAutoLogout(() => {
    const Logout = async () => {
      await ToggleSessionTimeout(
        sessionTimeoutPopup.title,
        sessionTimeoutPopup.description,
      );

      await loginService.Logout();
      localStorage.clear();
      navigate("/", { replace: true });
      window.location.reload();
    };

    Logout();
  });

  /* <summary>
  date: 15-05-2023
  Name: GM
  description: Gets the new Route as per logic below
  <summary>*/
  const GetRouteElement = () => {
    if (
      auth.urlBeforeLogin !== "" &&
      !NON_RESUMABLE_ROUTES.includes(auth.urlBeforeLogin) &&
      !auth.urlBeforeLogin.includes(PAGE_ROUTES.TRAINING_LOG) &&
      GetLocalStorageData("eUser")
    ) {
      return <Navigate to={auth.urlBeforeLogin} />;
    }

    if (GetLocalStorageData("eUser")) {
      return outlet;
    }

    return <Navigate to="/" />;
  };

  return GetRouteElement();
};
